var _desc, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLike(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    id: "Like--Streamline-Ultimate",
    height: 24,
    width: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Like Streamline Icon: https://streamlinehq.com")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M0.836304 10.2516H2.2263c2.0977 0.0003 4.1116 -0.0733 5.60793 -1.54353C9.33056 7.23792 10.1896 5.23888 10.2263 3.1415c0 -3.3849 4.278 -1.8 4.278 1.22v3.89c0 1.10457 0.8954 2.0001 2 2.0001h4.7084c1.0459 0 1.9251 0.8066 1.9458 1.8524 0.0659 3.3363 -0.4903 5.7631 -1.8394 8.346 -0.7779 1.4893 -2.3933 2.3206 -4.073 2.283C5.57052 22.4717 7.0808 20.5016 0.836304 20.5016",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLike);
export default __webpack_public_path__ + "static/media/like.66972826d96609960bc7de1062ed18b5.svg";
export { ForwardRef as ReactComponent };